import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import palletApi, { PalletData } from '../apis/pallet.api'
import { TransferData } from '../apis/transfer.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import InventoryHistoryTable from '../partials/InventoryHistoryTable'
import ItemCard from '../components/ItemCard'

interface InventoryHistoryRouteState {
  id: number
}

interface InventoryHistoryProps
  extends RouteComponentProps<any, any, InventoryHistoryRouteState> {}

interface InventoryHistoryState {
  pallet: PalletData | null
  transfers: TransferData[]
}

class InventoryHistory
  extends Component<InventoryHistoryProps, InventoryHistoryState> {
  constructor (props: InventoryHistoryProps) {
    super(props)
    this.state = {
      pallet: null,
      transfers: []
    }
  }

  get id () {
    return this.props.location.state.id
  }

  get itemCard () {
    const { pallet } = this.state
    if (
      !pallet ||
      !pallet.inventory ||
      !pallet.inventory.item ||
      !pallet.inventory.inventoriable
    ) return
    const item = pallet.inventory.item
    const { inventoriable, inventoriableType } = pallet.inventory
    const workOrderCode = (inventoriableType === 'workOrder')
      ? inventoriable.code
      : ''
    const purchaseOrderCode = (inventoriableType === 'purchaseOrder')
      ? inventoriable.code
      : ''
    return (
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc}
        workOrder={workOrderCode}
        purchaseOrder={purchaseOrderCode} />
    )
  }

  readPallet () {
    palletApi.read(this.id, pallet => {
      if (!pallet) return
      this.setState({ pallet })
    })
  }

  listTransfers () {
    palletApi.listTransfers(this.id, transfers => {
      if (!transfers) return
      this.setState({ transfers })
    })
  }

  componentDidMount () {
    this.readPallet()
    this.listTransfers()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <InventoryHistoryTable transfers={this.state.transfers} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(InventoryHistory)
